import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
// import AuthGuard from 'utils/route-guard/AuthGuard';

const SystemSettings = Loadable(lazy(() => import('views/system-settings')));

const Profile = Loadable(lazy(() => import('views/profile')));
const Deployments = Loadable(lazy(() => import('views/deployments')));
const DeploymentRequests = Loadable(lazy(() => import('views/deployment-requests')));
const Analytics = Loadable(lazy(() => import('views/analytics')));
const Trials = Loadable(lazy(() => import('views/trials')));
const TrialRequests = Loadable(lazy(() => import('views/trial-requests')));
const Clients = Loadable(lazy(() => import('views/clients')));
const Units = Loadable(lazy(() => import('views/units')));
const Support = Loadable(lazy(() => import('views/settings/support')));
const EmailTemplates = Loadable(lazy(() => import('views/settings/email-templates')));

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/analytics',
            element: <Analytics />
        },
        {
            path: '/system-settings',
            element: <SystemSettings />
        },
        {
            path: '/deployments',
            element: <Deployments />
        },
        {
            path: '/deployment-requests',
            element: <DeploymentRequests />
        },
        {
            path: '/trials',
            element: <Trials />
        },
        {
            path: '/trial-requests',
            element: <TrialRequests />
        },
        {
            path: '/clients',
            element: <Clients />
        },
        {
            path: '/units',
            element: <Units />
        },
        {
            path: '/support',
            element: <Support />
        },
        {
            path: '/my-profile',
            element: <Profile />
        },
        {
            path: '/email-templates',
            element: <EmailTemplates />
        }
    ]
};

export default MainRoutes;
